<template>
  <div class="noti-wrapper p-7">
    <p class="noti-title">{{ notification.title }}</p>
    <div v-if="notification.image?.length > 0" class="w-2/4">
      <img :src="notification.image" class="cover-image" />
    </div>

    <div v-html="notification.body" class="noti-body mt-5"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//   import store from "@/store"

export default {
  data() {
    return {
      notification: {}
    };
  },
  mounted() {
    // this.fetchNotifications();
    this.fetchNoti();
  },
  watch: {
    "$route.params.id"() {
      this.fetchNoti();
    }
  },
  methods: {
    ...mapActions("dashboard", [
      "setNotiReaders",
      "fetchNotification",
      "fetchNotifications"
    ]),
    async fetchNoti() {
      return await this.fetchNotification(this.$route.params.id).then(
        response => {
          this.notification = response.data.data;
        }
      );
    }
  },
  computed: {
    ...mapState({
      plan: state => state.loginmaster.details.plan,
      details: state => state.loginmaster.details,
      premium: state => state.loginmaster.details.premium_details,
      notifications: state => state.dashboard.notifications,
      allinsti: state => state.exam.allinstitutions,
      Categories: state => state.exam.allcategories,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin
    })
  }
};
</script>

<style scoped>
.noti-wrapper {
  background-color: white;
  border-radius: 20px 20px;
  min-height: 100vh;
  padding: 20px;
  margin-top: 40px;
}

.noti-title {
  font-size: 32px;
  font-weight: bold;
}

.noti-body {
  font-size: 16px;
}
.cover-image {
  width: 100%;
}
</style>
